import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import * as React from "react";
import Box from "@mui/material/Box";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import { IoArrowBackCircle } from "react-icons/io5";
import { useNavigate, useParams } from "react-router-dom";
import * as rootStore from "stores/root_store";
import { ProductDetail } from "services/product_services";
import "./productDetail.css";
import { ListStatusProduct } from "services/commonDate_services";
import moment from "moment";



export function createProductDetail() {
  return observer(() => {
    // ====================  STATE ===========================
    const [value, setValue] = useState("1");
    // Get the ID param from the URL
    const { productId = "" } = useParams();
    // product detail
    const [productDetail, setProductDetail] = useState<
      ProductDetail | undefined
    >(undefined);

    // get list dropdown moldtest
    const [listMoldTest, setListMoldTest] = useState<ListStatusProduct[]>([]);

    const [listStatus, setListStatus] = useState<ListStatusProduct[]>([]);

    const [type, setType] = useState<string>("");

    // =================== FUNTIONS =========================
    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
      setValue(newValue);
    };

    const handleChangeParentCategoryName = (
      e: React.ChangeEvent<HTMLInputElement>
    ) => {
      setProductDetail({
        ...productDetail,
        parentCategoryName: e.target.value,
      });
    };

    const navigate = useNavigate();
    const handleResetInput = () => {
      if (productDetail?.productName) {
        setProductDetail({
          ...productDetail,
          parentCategoryName: "",
          categoryName: "",
          categoryDetailName: "",
          categoryDetail2Name: "",
          productCode: "",
          productName: "",
          actived: false,
          isMold: false,
          status: "",
        });
        navigate(-1);
      } else {
        navigate(-1);
      }
    };

    useEffect(() => {
      const getProductDetail = async () => {
        await rootStore.productPresenter.getProductDetailById(
          rootStore.productStore,
          productId
        );
        const result = rootStore.productStore.getProductDetailByIdResponse.data;
        if (rootStore.productStore.getProductDetailByIdResponse.isSuccess) {
          setProductDetail(
            rootStore.productStore.getProductDetailByIdResponse.data
          );
        }
      };
      const getListStatusProduct = async () => {
        await rootStore.commonDatePresenter.getListStatusProduct(
          rootStore.commonDateStore
        );
        setListStatus(rootStore.commonDateStore.listStatusProductResponse.data);
      };

      getListStatusProduct();
      getProductDetail();
      getDropDownMoldTest();
    }, []);

    const getDropDownMoldTest = async () => {
      await rootStore.commonDatePresenter.getDropdownMoldTestResult(
        rootStore.commonDateStore,
        "MoldTestResult"
      );
      setListMoldTest(rootStore.commonDateStore.listStatusProductResponse.data);
    };

    useEffect(() => {
      productDetail?.status && setType(productDetail?.status);
    }, [productDetail?.status]);
    return (
      <div className="w-full py-3 px-5">
        <div className="flex items-center mb-3">
          <h3 className="text-md font-bold text-gray-800 uppercase hello">
            CHI TIẾT THÔNG TIN SẢN PHẨM
          </h3>
          {/* nút back */}
          <span
            onClick={handleResetInput}
            className="flex items-center text-xs text-primary cursor-pointer ml-3 font-medium"
          >
            <IoArrowBackCircle className="mr-2 text-base text-gray-500" />
            Quay lại
          </span>
        </div>
        <div className="w-full bg-white py-3 flex rounded mb-2 border border-neutral-300">
          <Box sx={{ width: "100%", typography: "body1" }}>
            <TabContext value={value && value}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <TabList
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                >
                  <Tab
                    sx={{ fontSize: 12, fontWeight: "700", color: "#000" }}
                    label="Thông tin sản phẩm"
                    value="1"
                  />
                  {/* <Tab
                    sx={{ fontSize: 12, fontWeight: '700', color: '#000' }}
                    label='Routing'
                    value='2'
                  /> */}
                </TabList>
              </Box>
              <TabPanel value="1">
                <form className="w-full flex flex-col mx-auto">
                  <div className="w-full sm:w-3/5 mx-auto text-[13px]">
                    {/* Phân cấp sản phẩm*/}
                    <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                      <label className="col-span-5 lg:col-span-1 font-bold text-gray-700 text-left lg:text-right">
                        Phân cấp sản phẩm
                      </label>
                      <input
                        disabled
                        onChange={handleChangeParentCategoryName}
                        value={
                          productDetail?.parentCategoryName
                            ? `${productDetail?.parentCategoryName}`
                            : ""
                        }
                        className="col-span-5 lg:col-span-4 bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                      />
                    </div>
                    {/* Nhóm sản phẩm*/}
                    <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                      <label className="col-span-5 lg:col-span-1 font-bold text-gray-700 text-left lg:text-right">
                        Nhóm sản phẩm
                      </label>
                      <input
                        disabled
                        value={
                          productDetail?.categoryName
                            ? `${productDetail?.categoryName}`
                            : ""
                        }
                        className="col-span-5 lg:col-span-4 bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                      />
                    </div>
                    {/* Nhóm sản phẩm chi tiết*/}
                    <div className=" sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                      <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                        Nhóm sản phẩm chi tiết
                      </label>
                      <input
                        disabled
                        value={
                          productDetail?.categoryDetailName
                            ? `${productDetail?.categoryDetailName}`
                            : ""
                        }
                        className="col-span-5 lg:col-span-4 bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                      />
                    </div>

                    {/* Kiểu dáng sản phẩm */}
                    <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                      <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                        Kiểu dáng sản phẩm
                      </label>
                      <input
                        disabled
                        value={productDetail?.categoryDetail2Name ? `${productDetail?.categoryDetail2Name}` : ''}
                        className="col-span-5 lg:col-span-4 disabled:bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                      />
                    </div>

                    {/* mã sản phẩm*/}
                    <div className=" sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                      <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                        Mã Sản Phẩm
                      </label>
                      <input
                        disabled
                        value={
                          productDetail?.productCode
                            ? `${productDetail?.productCode}`
                            : ""
                        }
                        className="col-span-5 lg:col-span-4 bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                      />
                    </div>
                    {/*  Tên Sản phẩm*/}
                    <div className=" sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                      <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                        Tên Sản phẩm
                      </label>
                      <input
                        disabled
                        value={
                          productDetail?.productName
                            ? `${productDetail?.productName}`
                            : ""
                        }
                        className="col-span-5 lg:col-span-4 bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                      />
                    </div>
                    {/* mô tả sản phẩm */}
                    <div className=" sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                      <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                        Mô tả sản phẩm
                      </label>
                      <input
                        disabled
                        value={
                          productDetail?.description
                            ? `${productDetail?.description}`
                            : ""
                        }
                        className="col-span-5 lg:col-span-4 bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                      />
                    </div>
                    {/* đơn vị tính */}
                    <div className=" sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                      <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                        Đơn vị tính
                      </label>
                      <input
                        disabled
                        value={
                          productDetail?.unit ? `${productDetail?.unit}` : ""
                        }
                        className="col-span-5 lg:col-span-4 bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                      />
                    </div>
                    {/* Ghi chú */}
                    <div className=" sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                      <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                        Ghi chú
                      </label>
                      <input
                        disabled
                        value={
                          productDetail?.ghiChu
                            ? `${productDetail?.ghiChu}`
                            : ""
                        }
                        className="col-span-5 lg:col-span-4 bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                      />
                    </div>

                    {productDetail?.isMold && (
                      <div>
                        {/* Bản vẽ khuôn */}
                        <div className=" sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                          <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                            Bản vẽ khuôn
                          </label>
                          <input
                            disabled
                            value={
                              productDetail?.moldDrawCode
                                ? `${productDetail?.moldDrawCode}`
                                : ""
                            }
                            className="col-span-5 lg:col-span-4 bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                          />
                        </div>
                        {/*Serial*/}
                        <div className=" sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                          <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                            Serial
                          </label>
                          <input
                            disabled
                            value={
                              productDetail?.serial
                                ? `${productDetail?.serial}`
                                : ""
                            }
                            className="col-span-5 lg:col-span-4 bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                          />
                        </div>

                        {/*  Tình trạng khuôn*/}
                        <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                          <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                            Tình trạng khuôn
                          </label>
                          <div className="flex py-1.5 text-default col-span-5 lg:col-span-4">
                            {listStatus.map((item) => (
                              <div
                                key={item.key}
                                className="mr-5 flex items-center justify-center"
                              >
                                <input
                                  id={`${item.key}`}
                                  type="radio"
                                  name="status"
                                  readOnly
                                  checked={type === item.key}
                                  className="mr-2"
                                />
                                <label htmlFor={`${item.key}`}>
                                  {item.value}
                                </label>
                              </div>
                            ))}
                          </div>
                        </div>
                        {/* ma film kiem tra */}
                        <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                          <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                            Mã film kiểm tra
                          </label>
                          <input
                            disabled
                            value={productDetail.printMoldFilm}
                            className="col-span-5 lg:col-span-4 bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                          />
                        </div>
                        {/*    Mã film chụp bản */}
                        <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                          <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                            Mã film chụp bản
                          </label>
                          <input
                            disabled
                            value={
                              productDetail.printMoldName &&
                              `${productDetail.printMoldName}`
                            }
                            className="col-span-5 lg:col-span-4 bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                          />
                        </div>
                        {/* kho khuôn */}
                        <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                          <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                            Kho khuôn
                          </label>
                          <input
                            disabled
                            value={
                              productDetail.locationNote
                                ? `${productDetail.locationNote}`
                                : ""
                            }
                            className="col-span-5 lg:col-span-4 bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                          />
                        </div>
                        {/* Bin */}
                        <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                          <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                            Bin
                          </label>
                          <input
                            disabled
                            value={productDetail.bin && `${productDetail.bin}`}
                            className="col-span-5 lg:col-span-4 bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                          />
                        </div>
                        {/* Current Bin */}
                        <div className=" sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                          <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                            Current Bin
                          </label>
                          <input
                            disabled
                            value={
                              productDetail.crrBin
                                ? `${productDetail.crrBin}`
                                : ""
                            }
                            className="col-span-5 lg:col-span-4 bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                          />
                        </div>

                        {/* Kích Thước / Quy Cách */}
                        <div className=" sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                          <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                            Kích Thước / Quy Cách
                          </label>
                          <input
                            disabled
                            value={
                              productDetail.specification
                                ? `${productDetail.specification}`
                                : ""
                            }
                            className="col-span-5 lg:col-span-4 bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                          />
                        </div>
                        {/* Kích Thước / Quy Cách SP */}
                        <div className=" sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                          <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                            Kích Thước / Quy Cách SP
                          </label>
                          <input
                            disabled
                            value={
                              productDetail.size ? `${productDetail.size}` : ""
                            }
                            className="col-span-5 lg:col-span-4 bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                          />
                        </div>

                        {/* Loại dao */}
                        <div className=" sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                          <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                            Loại dao
                          </label>
                          <input
                            disabled
                            value={
                              productDetail.knifeType
                                ? `${productDetail.knifeType}`
                                : ""
                            }
                            className="col-span-5 lg:col-span-4 bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                          />
                        </div>
                        {/* Loại máy bế */}
                        <div className=" sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                          <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                            Loại máy bế
                          </label>
                          <input
                            disabled
                            value={
                              productDetail.equipmentType
                                ? `${productDetail.equipmentType}`
                                : ""
                            }
                            className="col-span-5 lg:col-span-4 bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                          />
                        </div>
                        {/* Số SP/Khuôn */}
                        <div className=" sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                          <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                            Số SP/Khuôn
                          </label>
                          <input
                            disabled
                            value={
                              productDetail.productNum
                                ? `${productDetail.productNum}`
                                : ""
                            }
                            className="col-span-5 lg:col-span-4 bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                          />
                        </div>
                        {/* Tên nhà cung cấp */}
                        <div className=" sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                          <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                            Tên nhà cung cấp
                          </label>
                          <input
                            disabled
                            value={
                              productDetail.vendor
                                ? `${productDetail.vendor}`
                                : ""
                            }
                            className="col-span-5 lg:col-span-4 bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                          />
                        </div>
                        {/* Mã cũ */}
                        <div className=" sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                          <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                            Mã cũ
                          </label>
                          <input
                            disabled
                            value={
                              productDetail.oldCode
                                ? `${productDetail.oldCode}`
                                : ""
                            }
                            className="col-span-5 lg:col-span-4 bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                          />
                        </div>
                        {/* Thử ngiệm khuôn */}
                        <div className=" sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                          <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                            Thử nghiệm khuôn
                          </label>
                          <input
                            disabled
                            value={
                              productDetail.moldTest
                                ? `${listMoldTest.find(
                                  (i) => i.key === productDetail.moldTest
                                )?.value
                                }`
                                : ""
                            }
                            className="col-span-5 lg:col-span-4 bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                          />
                          {/* <select
                            defaultValue={
                              productDetail.moldTest !== undefined
                                ? `${productDetail.moldTest}`
                                : ''
                            }
                            className='col-span-5 lg:col-span-4 text-gray-700 border border-gray-300 px-3 py-1.5 text-default w-full focus-visible:outline-none focus:border-blue-500 caret-blue-600'
                          >
                            <option className='' value='' disabled>
                              -- Chọn thử nghiệm khuôn --
                            </option>
                            {success?.map((item, index) => {
                              return (
                                <option key={index} value={item.key}>
                                  {item.value}
                                </option>
                              );
                            })}
                          </select> */}
                        </div>
                        {/* Ngày mua mới */}
                        <div className=" sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                          <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                            Ngày mua mới
                          </label>
                          <input
                            disabled
                            value={
                              productDetail.buyDate &&
                              moment(productDetail.buyDate).format("DD/MM/YYYY")
                            }
                            className="col-span-5 lg:col-span-4 bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default flex-1 focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                          />
                        </div>
                        {/* Ngày thử nghiệm */}
                        <div className=" sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                          <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                            Ngày thử nghiệm
                          </label>
                          <input
                            disabled
                            value={
                              productDetail.testDate &&
                              moment(productDetail.testDate).format(
                                "DD/MM/YYYY"
                              )
                            }
                            className="col-span-5 lg:col-span-4 bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default flex-1 focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                          />
                        </div>
                        {/* Ngày đưa vào sử dụng */}
                        <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                          <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                            Ngày đưa vào sử dụng
                          </label>
                          <input
                            disabled
                            value={
                              productDetail.usedDate &&
                              moment(productDetail.usedDate).format(
                                "DD/MM/YYYY"
                              )
                            }
                            className="col-span-5 lg:col-span-4 bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default flex-1 focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                          />
                        </div>
                        {/*  Ngày bảo trì gần nhất */}
                        <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                          <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                            Ngày bảo trì gần nhất
                          </label>
                          <input
                            disabled
                            value={
                              productDetail.lastMaintenanceDate &&
                              moment(productDetail.lastMaintenanceDate).format(
                                "DD/MM/YYYY"
                              )
                            }
                            className="col-span-5 lg:col-span-4 bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default flex-1 focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                          />
                        </div>
                        {/*  Cảnh báo bảo trì(số ngày) */}
                        <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                          <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                            Cảnh báo bảo trì(số ngày)
                          </label>
                          <input
                            disabled
                            value={
                              productDetail.maintenanceAlert
                                ? `${productDetail.maintenanceAlert}`
                                : ""
                            }
                            className="col-span-5 lg:col-span-4 bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                          />
                        </div>
                        {/*  Ngày bảo trì tiếp theo */}
                        <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                          <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                            Ngày bảo trì tiếp theo
                          </label>
                          <input
                            disabled
                            value={
                              productDetail.nextMaintenanceDate &&
                              moment(productDetail.nextMaintenanceDate).format(
                                "DD/MM/YYYY"
                              )
                            }
                            className="col-span-5 lg:col-span-4 bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                          />
                        </div>
                        {/*  Cảnh báo bảo trì (số lần dập) */}
                        <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                          <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                            Cảnh báo bảo trì (số lần dập)
                          </label>
                          <input
                            disabled
                            value={
                              productDetail.stampQuantityAlert
                                ? `${productDetail.stampQuantityAlert}`
                                : ""
                            }
                            className="col-span-5 lg:col-span-4 bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                          />
                        </div>
                        {/*  Số lượng dập lũy kế */}
                        <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                          <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                            Số lượng dập lũy kế
                          </label>
                          <input
                            disabled
                            value={
                              productDetail.stampQuantity
                                ? `${productDetail.stampQuantity}`
                                : ""
                            }
                            className="col-span-5 lg:col-span-4 bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                          />
                        </div>
                        {/*  Số lượng dập hiện tại */}
                        <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                          <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                            Số lượng dập hiện tại
                          </label>
                          <input
                            disabled
                            value={
                              productDetail.currentStampQuantity
                                ? `${productDetail.currentStampQuantity}`
                                : ""
                            }
                            className="col-span-5 lg:col-span-4 bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                          />
                        </div>
                      </div>
                    )}

                    {/* trạng thái */}
                    <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                      <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                        Trạng thái
                      </label>
                      <div className="flex py-1.5 text-default col-span-5 lg:col-span-4">
                        {/* hiệu lực */}
                        <div className="mr-5 flex items-center justify-center">
                          <input
                            id="active"
                            type="radio"
                            name="actived"
                            checked={productDetail?.actived === true}
                            className="mr-2"
                            onChange={() => {
                              setProductDetail({
                                ...productDetail,
                                actived: true,
                              });
                            }}
                          />
                          <label htmlFor="active">Đang sử dụng</label>
                        </div>
                        {/* Đã hủy */}
                        <div className="mr-5 flex items-center justify-center">
                          <input
                            id="unactive"
                            type="radio"
                            name="actived"
                            checked={productDetail?.actived === false}
                            className="mr-2"
                            readOnly
                          />
                          <label htmlFor="unactive">Ngưng sử dụng</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </TabPanel>
              {/* <TabPanel value='2'>Routing</TabPanel> */}
            </TabContext>
          </Box>
        </div>
      </div>
    );
  });
}
